var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-col",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.dataLoading,
          expression: "dataLoading",
        },
      ],
      ref: "container",
      staticStyle: { width: "100%", height: "100%" },
    },
    [
      _c("span", [_vm._v(_vm._s(_vm.table.name))]),
      _c(
        "ux-grid",
        {
          ref: "plxTable",
          staticStyle: { width: "100%" },
          attrs: {
            id: "dsData",
            size: "mini",
            height: _vm.height,
            "checkbox-config": { highlight: true },
            "width-resize": true,
          },
        },
        _vm._l(_vm.fields, function (field) {
          return _c(
            "ux-table-column",
            {
              key: field.dataeaseName,
              attrs: {
                "min-width": "200px",
                field: field.dataeaseName,
                resizable: true,
              },
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  field.deType === 0
                    ? _c("svg-icon", {
                        staticClass: "field-icon-text",
                        attrs: { "icon-class": "field_text" },
                      })
                    : _vm._e(),
                  field.deType === 1
                    ? _c("svg-icon", {
                        staticClass: "field-icon-time",
                        attrs: { "icon-class": "field_time" },
                      })
                    : _vm._e(),
                  field.deType === 2 || field.deType === 3
                    ? _c("svg-icon", {
                        staticClass: "field-icon-value",
                        attrs: { "icon-class": "field_value" },
                      })
                    : _vm._e(),
                  field.deType === 5
                    ? _c("svg-icon", {
                        staticClass: "field-icon-location",
                        attrs: { "icon-class": "field_location" },
                      })
                    : _vm._e(),
                  _c("span", [_vm._v(_vm._s(field.name))]),
                ],
                1
              ),
            ],
            2
          )
        }),
        1
      ),
      _vm.table.name
        ? _c("span", { staticStyle: { "font-size": "12px" } }, [
            _vm._v(_vm._s(_vm.$t("chart.preview_100_data"))),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }